/**
 * What a fall in a Crucible leads to for a Veil-Touched (see docs/gameplay.md,
 * "Crucible Outcome Rules", #94 and #255). Falling itself costs nothing; only
 * re-manifesting does. Values are in essence exchange value (see
 * `ESSENCE_EXCHANGE_RATE`) and are first-pass numbers to tune.
 */

/**
 * Whether a body is down: its essence is spent (fallen for a player, dead
 * for an enemy). The one place the rule lives (#327).
 */
export function isDown(body: { readonly essence: number }): boolean {
    return body.essence <= 0;
}

/** Price of the first re-manifest in a run; it doubles with each death after. */
export const REMANIFEST_BASE_PRICE_VALUE = 50;

/** How long a fallen player has to choose before the Crucible casts them out. */
export const FALLEN_DECISION_MS = 10_000;

/** The re-manifest price after a player's `deathsThisRun`th death (1-based): 50, 100, 200, ... */
export function resolveRemanifestPrice(deathsThisRun: number): number {
    return REMANIFEST_BASE_PRICE_VALUE * 2 ** Math.max(0, deathsThisRun - 1);
}
